import React from 'react';
const tomos = [{
  color: '🟢',
  title: 'VOLUME 1',
  subtitle: 'MiniBasket U10-U12',
  desc: '50 allenamenti completi',
  features: 'Palleggio · Passaggio · Fondamentali · Coordinazione'
}, {
  color: '🟡',
  title: 'VOLUME 2',
  subtitle: 'U13-U15',
  desc: '50 allenamenti completi',
  features: 'Pick & Roll · Collaborazioni · Lettura del gioco'
}, {
  color: '🟠',
  title: 'VOLUME 3',
  subtitle: 'U17-U19',
  desc: '50 allenamenti completi',
  features: 'Tattica avanzata · Decision Making · Alto rendimento'
}, {
  color: '🔴',
  title: 'VOLUME 4',
  subtitle: 'Preparazione Fisica',
  desc: 'Protocolli specifici',
  features: 'Velocità · Agilità · Resistenza · Prevenzione'
}, {
  color: '🟣',
  title: 'VOLUME 5',
  subtitle: '101 Esercizi di Tiro',
  desc: '101 esercizi classificati',
  features: 'Per tutte le categorie'
}, {
  color: '⭐',
  title: 'VOLUME 6',
  subtitle: 'Scouting e Gestione',
  desc: 'Strumenti avanzati',
  features: 'Valutazioni · Monitoraggio · Comunicazione'
}];
const features = ['Programmazione annuale', 'Allenamenti completi', 'Obiettivi già definiti', 'Schede di valutazione', 'Monitoraggio giocatori', 'Adattamenti per gruppi piccoli', 'Varianti per categorie diverse'];
export function WhatYouGet() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-260">
      <div className="max-w-5xl mx-auto" data-id="element-261">
        <h2 className="text-3xl sm:text-5xl font-black text-[#0A0A0A] text-center mb-12 tracking-tight" data-id="element-262">
          I 6 Volumi Completi
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-263">
          {tomos.map(tomo => <div key={tomo.title} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm hover:shadow-md transition-shadow flex flex-col" data-id="element-264">
              <div className="flex items-center gap-3 mb-4" data-id="element-265">
                <span className="text-2xl" data-id="element-266">{tomo.color}</span>
                <div data-id="element-267">
                  <h3 className="font-black text-[#0A0A0A] text-sm tracking-wider uppercase" data-id="element-268">
                    {tomo.title}
                  </h3>
                  <p className="text-[#FF6B00] font-bold text-lg leading-tight" data-id="element-269">
                    {tomo.subtitle}
                  </p>
                </div>
              </div>
              <p className="text-[#0A0A0A] font-bold text-sm mb-2" data-id="element-270">
                {tomo.desc}
              </p>
              <p className="text-[#5A5A66] text-sm font-medium leading-relaxed mt-auto" data-id="element-271">
                {tomo.features}
              </p>
            </div>)}
        </div>

        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-272">
          <h4 className="text-center font-black text-[#0A0A0A] mb-6 uppercase tracking-wider text-sm" data-id="element-273">
            Cosa include ogni volume
          </h4>
          <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3" data-id="element-274">
            {features.map(f => <span key={f} className="text-[#0A0A0A] text-sm font-bold flex items-center gap-2" data-id="element-275">
                <span className="text-[#00C853] text-lg" data-id="element-276">✅</span> {f}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}